import { AccredibleIconComponentModule } from '@accredible-frontend-v2/new-components/icon';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  standalone: true,
  selector: 'accredible-banner',
  imports: [AccredibleIconComponentModule],
  templateUrl: './banner.component.html',
  styleUrls: ['./banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccredibleBannerComponent {
  image = input<string>();
  title = input<string>();
  description = input<string>();
  background = input<string>('linear-gradient(112.72deg, #1E2089 0%, #A90098 93.83%)');
}
